import { render, staticRenderFns } from "./EmailVerificationAlert.vue?vue&type=template&id=78be42bd&scoped=true"
import script from "./EmailVerificationAlert.vue?vue&type=script&lang=js"
export * from "./EmailVerificationAlert.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationAlert.vue?vue&type=style&index=0&id=78be42bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78be42bd",
  null
  
)

export default component.exports